import DocumentsAPI from './documents';

// Tramite-scoped file-document singleton.
// Owner id is the tramite id (the URL identifier for nested tramite routes).
export default new DocumentsAPI('tramites');
